import { TaxBase, TaxKind, TaxScope } from '~core/models/core.models';

export const getTaxBaseName = (value: TaxBase | undefined | null): string => {
  if (!value) {
    return '';
  }

  switch (value) {
    case TaxBase.HT:
      return 'Hors Taxes';

    case TaxBase.TTC:
      return 'TTC';

    default:
      return value;
  }
};

export const getTaxScopeName = (value: TaxScope | undefined | null): string => {
  if (!value) {
    return '';
  }

  switch (value) {
    case TaxScope.LINE:
      return 'Article';

    case TaxScope.INVOICE:
      return 'Facture';

    default:
      return value;
  }
};
TaxKind;

export const getTaxKindName = (value: TaxKind | undefined | null): string => {
  if (!value) {
    return '';
  }

  switch (value) {
    case TaxKind.STAMP:
      return 'TIMBRE';

    case TaxKind.OTHER:
      return 'AUTRES';

    default:
      return value;
  }
};
